<template>
  <div
    class="container-fluid infinite-list"
    infinite-scroll-immediate="false"
    infinite-scroll-disabled="disabled"
    v-infinite-scroll="getAppointReviewList"
  >
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <div class="card search-card">
      <div class="card-body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <div class="form-row">
            <!-- 申請日期 -->
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <ValidationProvider
                  :rules="{ dateRangeRequired: true }"
                  v-slot="{ errors }"
                >
                  <label for="">申請日期</label>
                  <date-picker
                    class="w-100"
                    type="date"
                    range
                    :disabled-date="disabledAfterToday"
                    placeholder="YYYY-MM-DD~YYYY-MM-DD"
                    v-model="applyDateRange"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>

            <!-- 任用單狀態 -->
            <div class="col-sm-12 col-md-2">
              <div class="form-group">
                <label for="">任用單狀態</label>
                <v-select
                  :options="status"
                  label="value"
                  :searchable="false"
                  :reduce="(status) => status.key"
                  v-model="searchCondition.status"
                >
                </v-select>
              </div>
            </div>
            <!-- 職務名稱 -->
            <div class="col-sm-12 col-md-2">
              <div class="form-group">
                <label for="">{{ i18n("Position.PositionName") }}</label>
                <v-select
                  :options="positionList"
                  label="PositionName"
                  placeholder="請選擇"
                  :reduce="(positionName) => positionName.PositionName"
                  v-model="searchCondition.positionName"
                >
                </v-select>
              </div>
            </div>

            <!-- 應聘者名字 -->
            <div class="col-sm-12 col-md-2">
              <div class="form-group">
                <label for="">應聘者名字</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="請輸入關鍵字"
                  v-model="searchCondition.name"
                />
              </div>
            </div>
            <!-- 應聘者Email -->
            <div class="col-sm-12 col-md-2">
              <div class="form-group">
                <label for="">應聘者 Email</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="請輸入關鍵字"
                  v-model="searchCondition.email"
                />
              </div>
            </div>

            <div class="col-sm-12 col-md-1">
              <button
                type="button"
                class="btn btn-primary"
                style="margin-top: 30px"
                @click="
                  (currentPage = 1),
                    (personList = []),
                    (totalPerson = 0),
                    handleSubmit(getAppointReviewList)
                "
              >
                {{ i18n("Buttons.Search") }}
              </button>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>

    <!-- 卡片顯示樣式 -->
    <div class="tool-list" v-if="personList.length > 0">
      <div class="tool-list-about-card">
        <span
          @click="gridStyle = 'block'"
          :class="{ active: gridStyle == 'block' }"
        >
          <eva-icon fill="#000" name="grid-outline" />
        </span>
        <span
          @click="gridStyle = 'list'"
          :class="{ active: gridStyle == 'list' }"
        >
          <eva-icon fill="#000" name="list-outline" />
        </span>
      </div>
    </div>

    <!-- 卡片列表 -->
    <div
      class="person-card-list"
      :class="{
        'list-style': gridStyle == 'list',
        'block-style': gridStyle == 'block',
      }"
    >
      <div
        v-for="(person, index) in personList"
        :key="index"
        class="person-card infinite-list-item"
      >
        <PersonCard ref="personCard" :showCheckbox="false" :person="person">
          <template v-slot:tag="{ props }">
            <div class="result">{{ props.Status }}</div>
          </template>

          <template v-slot:middleContent="{ props }">
            <table>
              <tr>
                <th>應徵職務</th>
                <td>{{ props.PositionName }}</td>
              </tr>
            </table>
          </template>

          <template v-slot:buttonGroup="{ props }">
            <button type="button" @click="showDetailModal(props)">
              {{ i18n("Buttons.ShowData") }}
            </button>
            <button
              v-if="props.Status === '新建'"
              type="button"
              @click="editAppointmentForm(props)"
            >
              編輯
            </button>
            <button
              v-if="props.Status === '新建'"
              type="button"
              @click="openReviewModal(props)"
            >
              送簽
            </button>
          </template>
        </PersonCard>
      </div>
    </div>

    <!-- 送審 Modal -->
    <div
      id="pendingModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <ValidationObserver ref="pendingValid" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(singOff)">
              <div class="modal-header">
                <span>送審</span>
              </div>
              <div class="modal-body">
                <label for="">簽核人員</label>
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <v-select
                    :options="supervisorOptions"
                    label="Name"
                    placeholder="請選擇"
                    v-model="supervisorData"
                  >
                    <template slot="option" slot-scope="option">
                      {{ option.Name }}
                    </template>
                  </v-select>
                  <p v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>
                <img class="job-position" src="@/assets/img/query.png" alt="" />
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  取消
                </button>
                <button type="submit" class="btn btn-success">送審</button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <!-- 各資訊總覽 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="detailCurrentPage = 0">
              <span>
                <eva-icon name="person-outline" fill="#FFF"></eva-icon>
                履歷
              </span>
            </a>
            <a @click.prevent="detailCurrentPage = 1">
              <span>
                <eva-icon name="message-circle-outline" fill="#FFF"></eva-icon>
                面談紀錄
              </span>
            </a>
            <a
              v-if="showAppointmentRecord"
              @click.prevent="detailCurrentPage = 2"
            >
              <span>
                <eva-icon name="clipboard-outline" fill="#FFF"></eva-icon>
                任用單
              </span>
            </a>
            <div
              class="close-show-detail"
              @click.prevent="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              ></eva-icon>
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="$common.downloadResumePDF(ResumeType, ResumeId)"
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="ResumeType === 'IDL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                  <DlResume
                    v-if="ResumeType === 'DL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 1" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">面談紀錄</div>
                    <div class="item"></div>
                  </div>
                  <InterviewRecord :MatchId="MatchId"></InterviewRecord>
                </section>
              </perfect-scrollbar>
            </transition>
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 2" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">任用單</div>
                    <div class="item"></div>
                  </div>
                  <AppointmentRecord :MatchId="MatchId"></AppointmentRecord>
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* global $ */
import moment from "moment";
// 公司LOGO
import Logo from "@/components/company/Logo.vue";
// 人員卡片
import PersonCard from "@/components/back/Card/Person";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";
// 面談紀錄
import InterviewRecord from "@/components/back/CandidateData/InterviewRecord";
// 任用單
import AppointmentRecord from "@/components/back/CandidateData/AppointmentRecord";

export default {
  name: "AppointmentSearch",

  components: {
    Logo,
    PersonCard,
    IdlResume,
    DlResume,
    InterviewRecord,
    AppointmentRecord,
  },
  data() {
    return {
      // 卡片顯示樣式 有 block / list 兩種
      gridStyle: "block",

      // 人員卡片列表
      personList: [],

      // 分頁
      totalPerson: 0, // 總數
      currentPage: 1, // 當前頁數

      // 查詢條件
      applyDateRange: null,
      positionList: [], // 職務列表
      searchCondition: {},

      // 各資訊總覽
      MatchId: null,
      ResumeId: null,
      isShowDetail: false, // 預設不顯示
      detailCurrentPage: 0, // 點擊選項
      ResumeType: null, // 履歷種類
      showAppointmentRecord: false, // 是否顯示任用單

      // 送審
      supervisorOptions: [],
      supervisorData: null,

      // 任用單狀態
      status: [
        { key: null, value: "全部" },
        { key: "新建", value: "新建" },
        { key: "簽核中", value: "簽核中" },
        { key: "通過", value: "通過" },
        { key: "否決", value: "否決" },
      ],
    };
  },

  methods: {
    // 取得任用審核列表 API
    getAppointReviewList() {
      const vm = this;
      const api = `${window.endpoints.api}/AppointmentModule/List/paging`;

      if (vm.totalPerson > 0) {
        if (vm.totalPerson > 30) {
          if (vm.totalPerson === vm.personList.length) {
            vm.stopGetNextPage = true;
            return;
          } else {
            vm.currentPage++;
            vm.stopGetNextPage = false;
          }
        } else {
          vm.stopGetNextPage = true;
          return;
        }
      }

      const params = {
        ...vm.searchCondition,
        applyUserId: vm.$cookies.get("userId"),
        applyTimeStart:
          vm.applyDateRange[0] === null
            ? null
            : moment(vm.applyDateRange[0]).format("YYYY-MM-DD"),
        applyTimeEnd:
          vm.applyDateRange[1] === null
            ? null
            : moment(vm.applyDateRange[1]).format("YYYY-MM-DD"),
        Page: vm.currentPage,
        PerPage: 30,
      };

      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .get(api, { params })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.Quantity > 0) {
              vm.totalPerson = response.data.Quantity;
              let newArr = response.data.Datas;

              let oldArr;
              if (vm.currentPage === 1) {
                oldArr = [];
              } else {
                oldArr = vm.personList;
              }
              vm.personList = oldArr.concat(newArr);
            }

            vm.$store.dispatch("updateLoading", false);
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$bus.$emit("message: push", error.response.data, "danger");
        });
    },

    // 送簽 Modal
    openReviewModal(person) {
      this.MatchId = person.MatchId;
      if (this.openK2) {
        this.singOff();
      } else {
        this.supervisorData = null;
        this.$refs.pendingValid.reset();
        $("#pendingModal").modal("show");
      }
    },

    // 送簽 API
    singOff() {
      let api, data;
      const vm = this;

      api = vm.openK2
        ? `${window.endpoints.api}/K2/Appointment/SignOff`
        : `${window.endpoints.api}/AppointmentModule/SignOff`;

      if (vm.openK2) {
        data = {
          MatchId: vm.MatchId,
          CreateUser: vm.$cookies.get("userName"),
        };
      } else {
        data = {
          DesignatedApprover: vm.supervisorData.Guid,
          MatchId: vm.MatchId,
          CreateUser: vm.$cookies.get("userName"),
        };
        $("#pendingModal").modal("hide");
      }

      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);

            vm.personList.forEach((item, index, arr) => {
              if (item.MatchId === data.MatchId) {
                arr[index].Status = "簽核中";
              }
            });

            vm.$notify({
              title: "成功",
              message: "送簽成功",
              type: "success",
              duration: 2500,
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "錯誤",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 編輯任用單
    editAppointmentForm(item) {
      this.$router.push({
        path: `/manager/form/evaluation/edit/${item.MatchId}`,
      });
    },

    // 檢視資訊 Modal
    showDetailModal(item) {
      this.MatchId = item.MatchId;
      this.ResumeId = item.ResumeId;
      this.ResumeType = item.ResumeType;
      this.showAppointmentRecord = item.Status !== "新建";
      this.isShowDetail = true;
    },

    // 檢視任用單 button
    viewAppointment(item) {
      localStorage.setItem("candidate", JSON.stringify(item));
      this.$router.push({
        path: `/manager/form/evaluationreview`,
      });
    },

    // 日期不得大於今日
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    async getData() {
      const backgroundUser = await this.$api.backgroundUser.getBackgroundUser();

      // 取得主管列表
      this.supervisorOptions = backgroundUser.data.map((user) => {
        return {
          Guid: user.UserId,
          Name: user.Name,
          Email: user.Email,
        };
      });
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    openK2: function () {
      return this.$store.state.openK2;
    },

    disabled() {
      return this.stopGetNextPage;
    },

    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    isShowDetail: function (e) {
      if (!e) {
        this.detailCurrentPage = 0;
      }
    },
  },

  created() {
    this.getData();

    this.applyDateRange = [
      new Date(this.$common.getLastMonth()),
      new Date(this.$common.getToday()),
    ];
    this.$set(this.searchCondition, "status", null);

    this.getAppointReviewList();

    // 取得職務列表
    this.get_position(null)
      .then((result) => {
        this.positionList = result;
      })
      .catch((error) =>
        this.$notify({
          title: "職務列表取得失敗",
          message: error.response.data,
          type: "error",
          duration: 3500,
        })
      );

    // 取得K2系統開關
    this.$store.dispatch("openK2");
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>
